function phoneMaskFunction(value, stateValue) {
    const unMaskedValue = value.length === 1 ? value : `${value.slice(3, 6)}${value.slice(7, 10)}${value.slice(11, 13)}${value.slice(14)}`;
    let result;
    if (unMaskedValue.length > 10
        || unMaskedValue.match(/\D/g)
        || (value.length > 1 && value[0] !== '+')
        || (value.length > 2 && value[2] !== '(')
        || (value.length > 6 && value[6] !== ')')
        || (value.length > 10 && value[10] !== '-')
        || (value.length > 13 && value[13] !== '-')
    ) {
        result = stateValue;
    } else if (value.length > stateValue.length) {
        if (value.length === 1) {
            if (value === '7') {
                result = `+${value}(`;
            } else if (value === '8') {
                const reg = /8/;
                const modifiedValue = value.replace(reg, '+7');
                result = `${modifiedValue}(`;
            } else {
                result = `+7(${value}`;
            }
        } else if (value.length === 6) {
            result = `${value})`;
        } else {
            result = (value.length === 10 || value.length === 13) ? `${value}-` : value;
        }
    } else if (value.length === 3) {
        result = '';
    } else {
        result = (value.length === 6 || value.length === 10 || value.length === 13)
            ? value.slice(0, value.length - 1)
            : value;
    }

    return result;
}

export default phoneMaskFunction;
